import React from 'react';
import PropTypes from 'prop-types';
import DashIcon from '@kyruus/react-ikons/Remove';

import { Handle, HeaderContent, HeaderText, SheetContent } from './styles';
import { SwipeableBottomDrawer } from 'Src/shared/BottomSheet/SwipeableBottomDrawer';

function BottomSheet({
  headerText,
  children,
  isOpen,
  handleClose,
  className,
  ...rest
}) {
  return (
    <SwipeableBottomDrawer
      isOpen={isOpen}
      handleClose={handleClose}
      className={`${className || ''}`}
      {...rest}
    >
      <Handle>
        <DashIcon size="24px" />
      </Handle>
      {headerText && (
        <HeaderContent>
          <HeaderText>{headerText}</HeaderText>
        </HeaderContent>
      )}
      <SheetContent>{children}</SheetContent>
    </SwipeableBottomDrawer>
  );
}

BottomSheet.propTypes = {
  headerText: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.node
};

export default BottomSheet;
